import * as React from "react";

import { IDayCell_Month } from "../../../classes/dayCell_Month";

import { MonthDayCellEvents } from "./MonthDayCellEvents";
import { MonthDayNumber } from "./MonthDayNumber";
import { MonthMoreEventsCount } from "./MonthMoreEventsCount";

import * as dates from "../../../reducers/changeTimePeriod";

export interface IMonthDayCell {
    allDayText: string;
    contextId: number;
    currentDate: Date;
    dayCell: IDayCell_Month;
    eventText: string;
    isLoading: boolean;
    monthStart: Date;
    objectId: number;
    onText: string;
    pageId: number;
    parentId: number;
    portalId: number;
    portletInstanceId: number;
    selectedDate: Date;
    todaysDate: Date;
    toText: string;
    userDateFormat: string;
    viewMode: string;
    onSetSelectedDate: (event: any) => any;
    onSetCurrentDate: (event: any) => any;
    onSetViewMode: (event: any) => any;
    onSetEventId: (eventId: number) => any;
    onSetEventScreenMode: (eventScreenMode: string) => any;
    onSetiCalStartDate: (iCalStartDate: Date) => any;
    onSetDisplayedEventLocalStartDate: (localStartDate: Date) => any;
    onSetDisplayedEventLocalEndDate: (localEndDate: Date) => any;
    onStartAjaxCall: (event: any) => any;
}

function getTDClassName(props: IMonthDayCell): string {
    const monthDifference = dates.getMonthsBetweenDates(props.dayCell.date, props.currentDate);
    let tdClassName = "";
    if (monthDifference !== 0) {
        tdClassName += "CAL-V-MV-otherMonth";
    }
    if (dates.isSameDay(props.dayCell.date, props.todaysDate)) {
        if (tdClassName.length > 0) { tdClassName += ""; }
        tdClassName += "CAL-V-today";
    }
    return tdClassName;
}

function getAnchorClassName(props: IMonthDayCell): string {
    let anchorClassName = "CAL-V-MV-selectDay";
    if (dates.isSameDay(props.dayCell.date, props.selectedDate)) {
        anchorClassName += " CAL-V-MV-SD-selected ";
    }
    return anchorClassName;
}

export const MonthDayCell = (props: IMonthDayCell) => {

    const tdClassName = getTDClassName(props);
    const anchorClassName = getAnchorClassName(props);
    const cellDate = props.dayCell.date.toString();

    let ariaLabel = dates.formatMonthDay(props.dayCell.date);
    ariaLabel += ", ";

    const numberOfEvents = props.dayCell.totalNumberEvents;
    if (numberOfEvents < 1) {
        ariaLabel += "no events"; // TODO: need to internationalize this...
    } else if (numberOfEvents === 1) {
        ariaLabel += "one event"; // TODO: need to internationalize this...
    } else {
        ariaLabel += numberOfEvents.toString() + " events"; // TODO: need to internationalize this...
    }

    return (
        <td className={tdClassName}>

            <a href="#!" className={anchorClassName} aria-label={ariaLabel} onClick={props.onSetSelectedDate} data-date={cellDate}><span className="offScreen">{ariaLabel}</span></a>

            <div className="CAL-V-MV-events">
                <MonthDayCellEvents
                    allDayText={props.allDayText}
                    contextId={props.contextId}
                    dayCell={props.dayCell}
                    eventText={props.eventText}
                    isLoading={props.isLoading}
                    monthStart={props.monthStart}
                    objectId={props.objectId}
                    onText={props.onText}
                    pageId={props.pageId}
                    parentId={props.parentId}
                    portalId={props.portalId}
                    portletInstanceId={props.portletInstanceId}
                    selectedDate={props.selectedDate}
                    todaysDate={props.todaysDate}
                    toText={props.toText}
                    userDateFormat={props.userDateFormat}
                    viewMode={props.viewMode}
                    onSetEventId={props.onSetEventId}
                    onSetEventScreenMode={props.onSetEventScreenMode}
                    onSetiCalStartDate={props.onSetiCalStartDate}
                    onSetDisplayedEventLocalStartDate={props.onSetDisplayedEventLocalStartDate}
                    onSetDisplayedEventLocalEndDate={props.onSetDisplayedEventLocalEndDate}
                    onStartAjaxCall={props.onStartAjaxCall}
                />
                <MonthMoreEventsCount
                    dayCell={props.dayCell}
                    isLoading={props.isLoading}
                    cellDate={props.dayCell.date}
                    onSetViewMode={props.onSetViewMode}
                    onSetCurrentDate={props.onSetCurrentDate}
                />
            </div>

            <MonthDayNumber
                date={props.dayCell.date}
                numberOfEvents={props.dayCell.totalNumberEvents}
                onSetViewMode={props.onSetViewMode}
                onSetCurrentDate={props.onSetCurrentDate}
                isMobileMode={false}
            />

        </td>
    );
};
